import * as React from "react";

function SvgIcons8NaturalUserInterface2(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M12 3C9.79 3 8 4.79 8 7c0 1.012.379 1.926 1 2.625v6.031l-2.094 2.688c-1.277 1.652-1.191 4.023.188 5.593l2.375 2.688A6.982 6.982 0 0014.719 29H20c3.855 0 7-3.145 7-7v-7c0-1.645-1.355-3-3-3-.535 0-1.031.156-1.469.406A2.999 2.999 0 0020 11c-.535 0-1.031.156-1.469.406A2.999 2.999 0 0016 10a2.95 2.95 0 00-1 .188v-.563c.617-.7 1-1.617 1-2.625 0-2.21-1.79-4-4-4zm0 3c.55 0 1 .45 1 1v9h2v-3c0-.566.434-1 1-1 .566 0 1 .434 1 1v3h2v-2c0-.566.434-1 1-1 .566 0 1 .434 1 1v2h2v-1c0-.566.434-1 1-1 .566 0 1 .434 1 1v7c0 2.773-2.227 5-5 5h-5.281a4.97 4.97 0 01-3.75-1.688l-2.375-2.718a2.338 2.338 0 01-.094-3l.5-.657V20h2V7c0-.129.02-.262.063-.375.003-.008-.004-.023 0-.031a.98.98 0 01.218-.313c.18-.18.446-.281.719-.281z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8NaturalUserInterface2);
